export const Address = ({ children }: { children: string }) => {
  const mapsUrl = `https://www.google.com/maps?q=${encodeURIComponent(children)}`;

  return (
    <a
      href={mapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="hover:underline hover:text-primary-200"
    >
      {children}
    </a>
  );
};
